import { getFlagsmithFlags } from '@lyka/utils'

type Flag = string | boolean | number

export type Flags = Record<string, Flag>

export async function useFlagsmith(): Promise<Flags> {
  const flags = await getFlagsmithFlags(import.meta.env.PUBLIC_FLAGSMITH_ENVIRONMENT_KEY)
  const enabled: Flags = {}

  for (const flag of flags) {
    if (flag.enabled && flag.feature_state_value !== null) {
      enabled[flag.feature.name] = flag.feature_state_value
    }
  }

  return enabled
}
